import http from 'plugins/axios'

export default {
  //更新后的查询所有用户信息
  getList(data) {
    return http.get({
      url: '/la/admin/user/coin/address/list',
      data,
    })
  },
}
